import { motion } from 'motion/react';

const TAB_INDICATOR_TRANSITION = { type: 'spring' as const, stiffness: 400, damping: 35 };

/** Sliding underline/background for router Link tabs. */
export function AnimatedTabIndicator({ layoutId, isActive, className = '' }: any) {
  if (!isActive) return null;
  return (
    <motion.span
      layoutId={layoutId}
      className={`pointer-events-none absolute inset-0 rounded-t-md border-b-2 border-brand-purple bg-dark-elevated ${className}`}
      transition={TAB_INDICATOR_TRANSITION}
    />
  );
}

export function animatedTabTriggerClass(isActive, extraClass = '') {
  return `tab-trigger-mdl relative inline-flex items-center gap-2 overflow-hidden border-b-2 px-4 py-3 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple/50 focus-visible:ring-offset-2 focus-visible:ring-offset-dark-base ${
    isActive
      ? 'border-transparent text-white'
      : 'border-transparent text-slate-400 hover:border-dark-border hover:text-slate-200'
  } ${extraClass}`.trim();
}
